enum ClaimsActivityVolumeLabelEnum {
  Core = "Core",
  Standard = "Standard",
  Peripheral = "Peripheral",
  Ghost = "Ghost",
  RxOnly = "RX Only",
  InsufficientData = "Insufficient Data",
  Total = "Total",
}

export { ClaimsActivityVolumeLabelEnum };